import { render } from "./NexusFooter.vue?vue&type=template&id=ffaceece"
import script from "./NexusFooter.vue?vue&type=script&lang=js"
export * from "./NexusFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__